import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '../shell/auth/auth.service';

/**
Attaches the Keycloak-issued Bearer token to outgoing requests.

Standalone-only, registered solely in `main.ts`'s interceptor chain, never
in `app.config.ts`'s federated one — in federated mode the Shell owns
authentication and this MFE never acquires its own token (see
`sessionExpiredInterceptor` for the same split).
@param request - Outgoing request.
@param next - Next handler in the interceptor chain.
@returns The handler's stream, with the Authorization header attached when a token is available.
*/
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(AuthService).getToken();

  if (!token) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
